import React, { useState, useEffect } from "react";
import { Row, Col, Divider, Modal, Form, Upload, message, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Resizer from "react-image-file-resizer";
import {
  createMedia,
  deleteMedia,
  storageUploadEvidenceImage,
} from "../../../../store/media/media.action";
import { useDispatch } from "react-redux";
import { descriptions, renderDescription } from "./string";
import { detailBranchSelector } from "../../../../store/branch/branch.selector";
import { labelDateSelector } from "../../../../store/var/var.selector";
import moment from "moment";
import lodash, { reject } from "lodash";
import { mediaSelector } from "../../../../store/media/media.selector";
import { useSelector } from "react-redux";

const CashupEvidence = ({ edit }) => {
  // -------------------------- VAR --------------------------
  const form = Form.useFormInstance();
  // -------------------------- STATE --------------------------
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const label = useSelector(labelDateSelector);
  const media = useSelector(mediaSelector);
  const fileList = media ? lodash.sortBy(media, ["createAt"]) : [];
  console.log({ branch, label, media });
  // -------------------------- FUNCTION --------------------------
  const handleUpload = (action) => {
    const file = action?.file;
    const name = file?.name;
    const uid = file?.uid;
    // if (file?.type === "image/jpeg") {
    //   Resizer.imageFileResizer(
    //     file,
    //     512,
    //     512,
    //     "jpg",
    //     96,
    //     0,
    //     (uri) => {
    //       if (uri) {
    //         let data = [...fileList, { name, uid: file?.uid, url: uri }];
    //         // setFileList(data);
    //         form.setFieldsValue({ evidences: data });
    //         // console.log({ uri });
    //         // create media
    //         const create = {
    //           url: uri,
    //           branch: branch?.id,
    //           date: label,
    //           onDate: moment(label, "DD/MM/YYYY")?.startOf("date")?.toDate(),
    //           source: "evidence",
    //           name: name,
    //         };
    //         dispatch(createMedia({ data: create }));
    //       }
    //     },
    //     "base64"
    //   );
    // } else {
    //   message.error("Please upload image file");
    // }

    if (file?.type === "image/jpeg") {
      Resizer.imageFileResizer(
        file,
        512,
        512,
        "jpg",
        96,
        0,
        (file) => {
          dispatch(
            storageUploadEvidenceImage({ file }, (res) => {
              if (res.status === 200) {
                const url = res?.data;
                if (url) {
                  // let data = [...fileList, { name, uid: file?.uid, url: url }];
                  // form.setFieldsValue({ evidences: data });
                  // create media
                  const create = {
                    branch: branch?.id,
                    date: label,
                    onDate: moment(label, "DD/MM/YYYY")
                      ?.startOf("date")
                      ?.toDate(),
                    source: "evidence",
                    name: name,
                    uid: uid,
                    url: url,
                  };
                  dispatch(createMedia({ data: create }));
                }
              } else {
                message.error(res.data || "Error! Please try again");
              }
            })
          );
        },
        "file"
      );
    } else {
      message.error("Please upload image file");
    }
  };

  const handlRemove = (action) => {
    // const id = action?.id;
    // const newFiles = fileList?.filter((f) => f?.uid !== uid);
    // setFileList(newFiles);
    // form.setFieldsValue({ evidences: newFiles });
    const mediaId = action?.id;
    // console.log(action);
    const promise = dispatch(
      deleteMedia({ mediaId }, (res) => {
        if (res?.status === 200) {
          message.success("Deleted successfully");
        } else {
          message.error("Error");
        }
      })
    );
    return false;
  };

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const renderModal = () => {
    return (
      <Modal
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    );
  };
  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Evidence: {renderDescription(descriptions.evidence)}</Col>
    </Row>
  );
  return (
    <Card className="item-card" title={title}>
      <Row style={{ marginTop: 10, width: "100%" }}>
        <Col span={24}>
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture-card"
            fileList={fileList}
            disabled={!edit}
            onPreview={handlePreview}
            customRequest={handleUpload}
            onRemove={handlRemove}
          >
            {fileList?.length > 10 ? null : uploadButton}
          </Upload>
        </Col>
        <Form.Item name="evidences"></Form.Item>
        {renderModal()}
      </Row>
    </Card>
  );
};

export default CashupEvidence;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
